<template>
    <div>
        <div
            class="serial"
            :class="[
                { 'serial--mass': theme == 'mass' },
                { 'serial--prestige': theme == 'prestige' }
            ]"
        >
            <div class="serial__tabs">
                <div
                    class="serial__tab"
                    :class="{ 'serial__tab--active': serialType == 'QR_CODE' }"
                    @click="changeTab('QR_CODE')"
                >
                    <div class="serial__tab-label">
                        {{ lbl.serial.qr_code }}
                    </div>
                </div>
                <div
                    class="serial__tab"
                    :class="{ 'serial__tab--active': serialType == 'CODE_128' }"
                    @click="changeTab('CODE_128')"
                >
                    <div class="serial__tab-label">
                        {{ lbl.serial.barcode }}
                    </div>
                </div>
                <div
                    class="serial__tab"
                    :class="{ 'serial__tab--active': serialType == 'CODE' }"
                    @click="changeTab('CODE')"
                >
                    <div class="serial__tab-label">
                        {{ lbl.serial.code }}
                    </div>
                </div>
            </div>
            <div class="serial__code-wrapper" v-if="isShowCode && isLoaded">
                <!-- Redemption Instruction -->
                <div class="serial__instruction">
                    {{ serialHeader }}
                </div>

                <div
                    class="serial__code serial__code--text"
                    v-show="serialType == 'CODE'"
                >
                    <p
                        class="serial__code-value"
                        :class="{
                            'serial__code-value--long': serial.length > 12,
                            'serial__code-value--expired': serial == 'XXXXXXX'
                        }"
                    >
                        {{ serial }}
                    </p>
                    <div class="serial__copy-button">
                        <span
                            class="serial__copy-text"
                            v-clipboard:copy="serial"
                            v-clipboard:success="onCopyCode"
                            v-clipboard:error="onErrorCode"
                            >{{ lbl.serial.copy_code }}</span
                        >
                        <img
                            src="@/assets/icon/ic-copy-code.svg"
                            alt="copy codeds"
                        />
                        <!-- <svg class="serial__copy-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.33333 5.33333H4C3.26362 5.33333 2.66667 5.93029 2.66667 6.66667V12C2.66667 12.7364 3.26362 13.3333 4 13.3333H9.33333C10.0697 13.3333 10.6667 12.7364 10.6667 12V10.6667M10.6667 2.66667H12C12.7364 2.66667 13.3333 3.26362 13.3333 4V9.33333C13.3333 10.0697 12.7364 10.6667 12 10.6667H6.66667C5.93029 10.6667 5.33333 10.0697 5.33333 9.33333V4C5.33333 3.26362 5.93029 2.66667 6.66667 2.66667H8" stroke="#DC2626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg> -->
                    </div>
                    <div class="serial__unavailable" v-if="!isAvailable">
                        <div
                            class="serial__unavailable-wrapper"
                            :class="[
                                {
                                    'serial__unavailable-wrapper--mass':
                                        theme == 'mass'
                                },
                                {
                                    'serial__unavailable-wrapper--prestige':
                                        theme == 'prestige'
                                }
                            ]"
                        >
                            <div class="serial__unavailable-text">
                                {{ reasonMsg }}
                            </div>
                        </div>
                    </div>
                    <div
                        class="serial__unavailable"
                        v-else-if="
                            (isAvailable &&
                                info &&
                                info[0] == 'type_transfer') ||
                                ((!isMinPrivilegeMatch ||
                                    isMinPrivilegeMatch == null) &&
                                    tag == 'history')
                        "
                    >
                        <div
                            class="serial__unavailable-wrapper"
                            :class="[
                                {
                                    'serial__unavailable-wrapper--mass':
                                        theme == 'mass'
                                },
                                {
                                    'serial__unavailable-wrapper--prestige':
                                        theme == 'prestige'
                                }
                            ]"
                        >
                            <div
                                class="serial__unavailable-text"
                                :class="{
                                    'serial__unavailable-text--min-privilege':
                                        !isMinPrivilegeMatch ||
                                        isMinPrivilegeMatch == null
                                }"
                                v-html="reasonMsg"
                            ></div>
                        </div>
                    </div>
                </div>
                <div
                    class="serial__code serial__code--barcode"
                    v-show="serialType == 'CODE_128'"
                >
                    <div class="serial__barcode">
                        <VueBarcode
                            class="serial__barcode-image"
                            :value="campaign.serial"
                            :options="barcodeConfig"
                        />
                    </div>
                    <div class="serial__unavailable" v-if="!isAvailable">
                        <div
                            class="serial__unavailable-wrapper"
                            :class="[
                                {
                                    'serial__unavailable-wrapper--mass':
                                        theme == 'mass'
                                },
                                {
                                    'serial__unavailable-wrapper--prestige':
                                        theme == 'prestige'
                                }
                            ]"
                        >
                            <div class="serial__unavailable-text">
                                {{ reasonMsg }}
                            </div>
                        </div>
                    </div>
                    <div
                        class="serial__unavailable"
                        v-else-if="
                            (isAvailable &&
                                info &&
                                info[0] == 'type_transfer') ||
                                ((!isMinPrivilegeMatch ||
                                    isMinPrivilegeMatch == null) &&
                                    tag == 'history')
                        "
                    >
                        <div
                            class="serial__unavailable-wrapper"
                            :class="[
                                {
                                    'serial__unavailable-wrapper--mass':
                                        theme == 'mass'
                                },
                                {
                                    'serial__unavailable-wrapper--prestige':
                                        theme == 'prestige'
                                }
                            ]"
                        >
                            <div
                                class="serial__unavailable-text"
                                :class="{
                                    'serial__unavailable-text--min-privilege':
                                        !isMinPrivilegeMatch ||
                                        isMinPrivilegeMatch == null
                                }"
                                v-html="reasonMsg"
                            ></div>
                        </div>
                    </div>
                </div>
                <div
                    class="serial__code serial__code--qrcode"
                    v-show="serialType == 'QR_CODE'"
                >
                    <div class="serial__qrcode">
                        <VueQrcode
                            :value="campaign.serial"
                            :options="qrcodeConfig"
                        />
                    </div>
                    <div class="serial__unavailable" v-if="!isAvailable">
                        <div
                            class="serial__unavailable-wrapper"
                            :class="[
                                {
                                    'serial__unavailable-wrapper--mass':
                                        theme == 'mass'
                                },
                                {
                                    'serial__unavailable-wrapper--prestige':
                                        theme == 'prestige'
                                }
                            ]"
                        >
                            <div class="serial__unavailable-text">
                                {{ reasonMsg }}
                            </div>
                        </div>
                    </div>
                    <div
                        class="serial__unavailable"
                        v-else-if="
                            (isAvailable &&
                                info &&
                                info[0] == 'type_transfer') ||
                                ((!isMinPrivilegeMatch ||
                                    isMinPrivilegeMatch == null) &&
                                    tag == 'history')
                        "
                    >
                        <div
                            class="serial__unavailable-wrapper"
                            :class="[
                                {
                                    'serial__unavailable-wrapper--mass':
                                        theme == 'mass'
                                },
                                {
                                    'serial__unavailable-wrapper--prestige':
                                        theme == 'prestige'
                                }
                            ]"
                        >
                            <div
                                class="serial__unavailable-text"
                                :class="{
                                    'serial__unavailable-text--min-privilege':
                                        !isMinPrivilegeMatch ||
                                        isMinPrivilegeMatch == null
                                }"
                                v-html="reasonMsg"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="serial__privilege-message"
                v-if="!isShowCode && isLoaded"
            >
                {{ privilegeMsg }}
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
//plugin
import VueBarcode from "@chenfengyuan/vue-barcode"; // https://github.com/fengyuanchen/vue-barcode/blob/master/README.md
import VueQrcode from "@chenfengyuan/vue-qrcode"; // https://github.com/fengyuanchen/vue-qrcode

import VueClipboard from "vue-clipboard2";
import Util from "@/helper/Utility.js";
import Locale from '@/helper/locale/locale.js';
export default {
    name: "Serial",
    components: {
        VueBarcode,
        VueQrcode
    },
    computed: {
        theme: function() {
            return this.$store.state.theme;
        },
        isMinPrivilegeMatch: function() {
            if (!this.campaign || !this.campaign.meta) return null;
            // if no minPrivilege requirement, show that no need to check
            if (!this.campaign.meta.minPrivilege || this.campaign.meta.minPrivilege.length === 0) {
                return true;
            }
            // if there is matchPrivilege and data, show that match
            return this.campaign.meta.matchPrivilege && this.campaign.meta.matchPrivilege.length > 0;
        }
    },
    props: {
        lbl: Object,
        tag: String,
        campaign: Object,
        campaignGroup: String,
        controller: Object
    },
    data: function() {
        return {
            serialHeader: "",
            serial: "",
            serialType: "",
            isExpired: false,
            isLoaded: false,
            isShowCode: true,
            isTabLock: false,
            isAvailable: true,
            reasonMsg: "",
            barcodeConfig: {
                height: 100,
                displayValue: false,
                lineColor: "#000000"
            },
            qrcodeConfig: {
                width: 160,
                margin: 0
            },

            privilegeMsg: "",
            info: null,
            localeCode: Locale.getLocaleCode()
        };
    },
    created: function() {
        VueClipboard.config.autoSetContainer = true;
        Vue.use(VueClipboard);

        // switch (this.campaignGroup) {
        //     case "1":
        //     case "2":
        //     case "3":
        //         this.serialHeader = this.lbl.serial.group_one_show_code;
        //         break;
        //     case "5":
        //     case "6":
        //         this.serialHeader = this.lbl.serial.group_five_show_code;
        //         break;
        //     default:
        //         this.serialHeader = this.lbl.serial.show_code_at_shop;
        //         break;
        // }
        this.initial();
    },
    mounted: function() {
        this.controller.cbSerialExpired.onCallback(this.serialExpired);
    },
    methods: {
        //event
        changeTab: function(type) {
            if (this.isTabLock) return;

            this.serialType = type;
            switch (this.serialType) {
                case "CODE_128":
                    this.handleTextHeader(this.lbl.serial.barcode);
                    break;
                case "QR_CODE":
                    this.handleTextHeader(this.lbl.serial.qr_code);
                    break;
                default:
                    this.handleTextHeader(this.lbl.serial.code);
                    break;
            }
        },
        //initial
        initial: function() {
            if (!this.campaign.serial) return;

            this.isExpired = false;
            this.serial = this.campaign.serial;
            switch (this.campaign.barcode) {
                case "CODE_128":
                    this.serialType = "CODE_128";
                    this.handleTextHeader(this.lbl.serial.barcode);
                    break;
                case "QR_CODE":
                    this.serialType = "QR_CODE";
                    this.handleTextHeader(this.lbl.serial.qr_code);
                    break;
                default:
                    this.serialType = "CODE";
                    this.handleTextHeader(this.lbl.serial.code);
                    break;
            }

            if (
                this.campaign.barcode &&
                this.campaign.barcode.toLowerCase() == "none" &&
                this.campaign.privilegeMessage
            )
                this.isShowCode = false;

            // this.initialPrivilegeMsg();
            if (this.tag == "history") this.initialAvailable();

            this.$nextTick(() => {
                this.isLoaded = true;
            });
        },
        // initialPrivilegeMsg: function() {
        //     if (this.campaign.privilegeMessage) {
        //         if (this.campaign.privilegeMessageFormat) {
        //             var privilegeMessageFormat = this.campaign.privilegeMessageFormat.toLowerCase();
        //             switch (privilegeMessageFormat) {
        //                 case "link":
        //                     //reserve for landing
        //                     this.privilegeMsg = this.lbl.serial.show_code_at_shop;
        //                     break;
        //                 case "html":
        //                     this.privilegeMsg = this.campaign.privilegeMessage;
        //                     break;
        //             }
        //         }
        //     } else {
        //         this.privilegeMsg = this.lbl.serial.show_code_at_shop;
        //     }
        // },
        handleTextHeader: function(type) {
            if (this.serialType == 'CODE_128' || this.serialType == 'QR_CODE') {
                var textType = this.localeCode == 1054 ? `${this.lbl.serial.code}${type}` : `${type}`;
                this.serialHeader = Util.stringFormat(this.lbl.serial.show_code_at_shop, textType); 
                return;
            } else {
                this.serialHeader = Util.stringFormat(this.lbl.serial.show_code_at_shop, type);
            }
        },
        initialAvailable: function() {
            if (!this.campaign.isAvailable) {
                this.isAvailable = false;
                this.reasonMsg = status;
                switch (this.campaign.status) {
                    case "cancelled":
                        this.reasonMsg = this.lbl.serial.cancel;
                        break;
                    case "expired":
                        this.reasonMsg = this.lbl.serial.expired;
                        break;
                    case "used":
                        if (this.campaign.extension.Group == "1") {
                            // this.reasonMsg = this.campaign.serial;
                            this.isAvailable = true;
                        } else {
                            this.reasonMsg = this.lbl.serial.used;
                        }
                        break;
                }
            } else {
                if (
                    !this.isMinPrivilegeMatch ||
                    this.isMinPrivilegeMatch == null
                ) {
                    this.reasonMsg = this.lbl.serial.min_match;
                } else {
                    var transfer = this.campaign.info1;
                    if (transfer) {
                        this.info = transfer.split("|");
                        if (
                            this.campaign.status == "used" &&
                            this.info &&
                            this.info[0] == "type_transfer"
                        ) {
                            if (this.info.length >= 0) {
                                this.reasonMsg = this.lbl.serial.transfer;
                            }
                        }
                    }
                }
            }
        },
        //copy clipboard
        onCopyCode: function(e) {
            console.log("copied", e.text);
            // show success toast when copy success
            if (this.controller && this.controller.copySuccessToast) {
                this.controller.copySuccessToast
                    .clearToast()
                    .setTitle(this.lbl.serial.copy_success_title)
                    .show();
            }
        },
        onErrorCode: function(e) {
            console.log("failed", e);
        },
        //bus
        serialExpired: function() {
            this.isShowCode = false;

            this.serial = "XXXXXXX";
            this.$emit('serialExpired', this.serial);
            this.isExpired = true;
            this.isAvailable = false;
            this.reasonMsg = this.lbl.serial.expired;

            this.$nextTick(() => {
                this.isShowCode = true;
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/button.scss";

.serial {
    .serial__tabs {
        display: flex;
        background-color: $color-gray-3;
        border-radius: 8px;
        margin-bottom: 20px;
        overflow: hidden;

        .serial__tab {
            flex: 1;
            padding: 10px 16px;
            cursor: pointer;
            text-align: center;

            &:nth-child(2) {
                border-left: 1px solid $color-white;
                border-right: 1px solid $color-white;
            }

            .serial__tab-label {
                font-size: 14px;
                font-weight: 500;
                color: $color-gray;
            }

            &.serial__tab--active {
                background-color: $color-blue;

                .serial__tab-label {
                    color: $color-white;
                    font-weight: 600;
                }
            }

            // &:hover:not(.serial__tab--active) {
            //     background-color: $color-gray-3;
            // }
        }
    }

    .serial__instruction {
        font-size: 14px;
        color: $color-gray;
        text-align: center;
        margin-bottom: 20px;
    }

    .serial__code-wrapper {
        position: relative;
        padding: 10px 10px 0;
        // padding: 0 10px;

        .serial__code {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 160px;
            margin: {
                top: 25px;
                bottom: 25px;
            }

            &--text {
                .serial__code-value {
                    font-family: var(--font-family-thai), sans-serif;
                    font-size: 32px;
                    font-weight: 500;
                    color: $color-gray;
                    text-align: center;
                    margin: 20px 0 0 0;
                    line-height: 1.2;
                    word-break: break-word;

                    &.serial__code-value--long {
                        font-size: 32px;
                        letter-spacing: 1px;
                    }

                    &.serial__code-value--expired {
                        color: #a5a5a5;
                    }
                }

                .serial__copy-button {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    // width: 100px;
                    padding: 6px 10px;
                    background-color: $color-white;
                    border: 1.5px solid $color-red;
                    border-radius: 8px;
                    cursor: pointer;
                    margin-top: 8px;

                    .serial__copy-icon {
                        flex-shrink: 0;
                    }

                    .serial__copy-text {
                        font-size: 14px;
                        font-weight: 600;
                        color: $color-red;
                        display: flex;
                        flex-wrap: nowrap;
                    }
                }
            }

            &--barcode {
                .serial__barcode {
                    width: fit-content;
                    flex: 0 0 fit-content;
                    margin: auto;
                    max-width: 100%;

                    .serial__barcode-image {
                        max-width: 100%;
                    }
                }
            }

            &--qrcode {
                .serial__qrcode {
                    width: 160px;
                    flex: 0 0 160px;
                    margin: {
                        left: auto;
                        right: auto;
                    }
                }
            }
        }

        .serial__unavailable {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;

            .serial__unavailable-wrapper {
                position: relative;
                width: 100%;
                height: 100%;

                .serial__unavailable-text {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    right: 0;
                    padding: {
                        top: 20px;
                        bottom: 25px;
                    }
                    transform: translateY(-50%);
                    color: $color-gray-4;
                    font-size: 32px;
                    font-weight: 500;
                    text-align: center;

                    &.serial__unavailable-text--min-privilege {
                        font-size: 32px;
                        font-weight: 500;
                        text-align: center;
                    }
                }

                &.serial__unavailable-wrapper--mass {
                    background-color: $color-white;
                    // background-color: rgba(#ffffff, 0.95);

                    // .serial__unavailable-text {
                    //     background-color: #ffffff;
                    // }
                }

                &.serial__unavailable-wrapper--prestige {
                    background-color: $color-white;

                    // .serial__unavailable-text {
                    //     background-color: #fffdf8;
                    // }
                }
            }
        }
    }
}
</style>
